import React, { useEffect, useState } from 'react'
import axios from 'axios';
import * as CONSTANTS from "../../../CONSTANTS";
import './mini-dashboard.css';
import { toast } from 'react-toastify';


function DashboardMessage({user, selectedEvent}) {
    const [listRSVP, setListRSVP]                             = useState([]);
    const [processing, setProccessing]                        = useState(false);

    useEffect(() => {
      if(selectedEvent){
        collectMyRSVPOnvites();
      }
    },[])
  
    const collectMyRSVPOnvites = async () => {
  
        try{
           const resData = await axios.get(CONSTANTS.API_URL + 'annivites/rsvp/v1/list/' + selectedEvent._id, {
                    headers: {
                      token: 'Bearer ' + user.accessToken,
                    },
                  }
                );   
                setListRSVP(resData.data.results);
              
        }catch(err){
          console.log(err);
        }
    }
  
    const handleToggleSwitch = async (id, currentValue) => {
      try{

        setProccessing(true);
        const updateMessage = {
              id,
          showMessage: currentValue
        }


         const resUpdate = await axios.put(CONSTANTS.API_URL + 'annivites/rsvp/v1/update/show', updateMessage,{
                          headers: {
                            token: 'Bearer ' + user.accessToken,
                          },
                        }
                    );

          if(resUpdate.data.showMessage){
            toast.success(resUpdate.data.name + " will have their message shown on the invite.");
          }else {
             toast.success(resUpdate.data.name + " will not have their message on your invite.");
          }

          setListRSVP(prevList =>
              prevList.map(p =>
                p._id === id ? { ...p, showMessage: currentValue } : p
              )
            );
            
          setProccessing(false);
      }catch(err){
        console.log(err);
        setProccessing(false);
      }
    }

  return (
    <div className="dashboard-inner-box">
       <div className="header-bar">
        <h5>Messages</h5>      
      </div>
       <div className="info-fields-layout">
        {
          listRSVP &&
          listRSVP.length > 0 && (
            <table className="table table-striped table-hover">
              <tbody>
                {
                  listRSVP.map((person, index) => {
                    return <tr key={index}>
                              <td>
                                <div className="flexme space-bt">
                                  <strong>{person.name}</strong>
                                  <div className="switch-boot-item">
                                      {
                                        person.showMessage ? 
                                            "Show message on invite."
                                          : "Do not show message."
                                       }

                                       <div className="form-check form-switch">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            checked={person.showMessage}
                                            onChange={() => handleToggleSwitch(person._id, !person.showMessage)}
                                          />
                                        </div>
                                    </div>
                                </div>
                                {person.message}
                                </td>
                           </tr>
                  })
                }
              </tbody>
            </table>
          )
        }
       </div>
    </div>
  )
}

export default DashboardMessage